import { Controller } from 'stimulus'

// Overlay da composicao de um Produto Composto, aberto pelo link "Produto Composto"
// na celula do item.
//
// Diferente de `dropdown_controller`, posiciona com `position: fixed` e coordenadas
// calculadas a partir do botao: a celula do item e um grid com `max-width: 33vw` e
// `overflow` proprio, entao um overlay no fluxo do documento seria cortado.
//
// Cada item do pedido monta sua propria instancia (o `data-controller` fica no
// wrapper do link), por isso `buttonTarget`/`overlayTarget` sempre resolvem para o
// item correto.
const GAP = 4

export default class extends Controller {
  static targets = ['button', 'overlay']

  connect() {
    document.addEventListener('click', this.closeOnOutsideClick)
    document.addEventListener('keydown', this.closeOnEscape)
    window.addEventListener('resize', this.reposition)
    // `true` para capturar scroll de qualquer container, e nao so do window:
    // a tabela de itens rola dentro do painel da aba.
    window.addEventListener('scroll', this.reposition, true)
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnOutsideClick)
    document.removeEventListener('keydown', this.closeOnEscape)
    window.removeEventListener('resize', this.reposition)
    window.removeEventListener('scroll', this.reposition, true)
  }

  // Sem `stopPropagation`: o clique precisa chegar ao `document` para que as *outras*
  // instancias o vejam como externo e fechem. Dois overlays abertos ao mesmo tempo se
  // sobrepoem na tela, porque ambos sao `position: fixed`. Esta instancia nao se fecha
  // sozinha porque `closeOnOutsideClick` ignora cliques dentro de `this.element`, e o
  // botao esta dentro dele.
  toggle = event => {
    event.preventDefault()

    if (this.isOpen) this.close()
    else this.open()
  }

  open = () => {
    this.overlayTarget.hidden = false
    this.overlayTarget.classList.add('is-visible')
    this.element.classList.add('is-active')
    this.toggleIcon(true)
    this.reposition()
  }

  close = () => {
    this.overlayTarget.classList.remove('is-visible')
    this.overlayTarget.hidden = true
    this.element.classList.remove('is-active')
    this.toggleIcon(false)
  }

  get isOpen() {
    return this.overlayTarget.classList.contains('is-visible')
  }

  // Abre para baixo por padrao; sobe quando nao ha espaco ate o fim da viewport.
  // Alinha pela esquerda do botao e recua se passar da borda direita.
  reposition = () => {
    if (!this.isOpen) return

    const button = this.buttonTarget.getBoundingClientRect()
    const overlay = this.overlayTarget
    const { offsetWidth: width, offsetHeight: height } = overlay

    let top = button.bottom + GAP
    if (top + height > window.innerHeight && button.top - height - GAP > 0) {
      top = button.top - height - GAP
    }

    const maxLeft = window.innerWidth - width - GAP
    const left = Math.max(GAP, Math.min(button.left, maxLeft))

    overlay.style.top = `${top}px`
    overlay.style.left = `${left}px`
  }

  closeOnOutsideClick = event => {
    if (!this.isOpen) return
    if (this.element.contains(event.target) || this.overlayTarget.contains(event.target)) return

    this.close()
  }

  closeOnEscape = event => {
    if (event.key === 'Escape') this.close()
  }

  toggleIcon(open) {
    const icon = this.buttonTarget.querySelector('i.ch-icon')
    if (!icon) return

    icon.classList.toggle('fa-chevron-down', !open)
    icon.classList.toggle('fa-chevron-up', open)
  }
}
